import { createContext, useContext } from 'react';
import type { Me, OrgDetail, OrgSummary } from '@unitly/contracts';

export interface QuickAddDefaults {
  kind?: 'task' | 'content' | 'event';
  workspaceId?: string;
  dueDate?: string;
}

export interface OrgCtx {
  orgId: string;
  slug: string;
  org: OrgSummary;
  detail: OrgDetail | undefined;
  me: Me;
  timeZone: string;
  today: string;
  base: string;
  openTask: (id: string) => void;
  openContent: (id: string) => void;
  openQuickAdd: (defaults?: QuickAddDefaults) => void;
  openSearch: () => void;
  openCreateWorkspace: () => void;
  openHomeCustomize: () => void;
}

export const OrgContext = createContext<OrgCtx | null>(null);

export function useOrgCtx(): OrgCtx {
  const ctx = useContext(OrgContext);
  if (!ctx) throw new Error('useOrgCtx outside OrgLayout');
  return ctx;
}
